import fromUnixTime from 'date-fns/fromUnixTime';

// ref: https://developers.google.com/search/docs/data-types/event?hl=zh-tw
// testing tool: https://search.google.com/test/rich-results
// FIXME: update event status
function renderSchema(event, locale, coverPhoto) {
  // const desc = stripHTML(job.description);
  return {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: event.name,
    startDate: new Date(fromUnixTime(event.startedAt)).toISOString(),
    endDate: new Date(fromUnixTime(event.endedAt)).toISOString(),
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    location: {
      '@type': 'VirtualLocation',
      url:
        locale === 'en-US'
          ? `https://nutshell.live/events/${event.id}`
          : `https://nutshell.live/${locale}/events/${event.id}`,
    },
    image: [coverPhoto],
    description: event.description,
    //TODO: update offers here
    // offers: {
    //   "@type": "Offer",
    //   url: "https://www.example.com/event_offer/12345_201803180430",
    //   price: "30",
    //   priceCurrency: "USD",
    //   availability: "https://schema.org/InStock",
    //   validFrom: "2024-05-21T12:00",
    // },
    performer: {
      '@type': 'PerformingGroup',
      name: 'Event Host',
    },
    organizer: {
      '@type': 'Organization',
      name: 'Nutshell Live',
      url: 'https://nutshell.live',
    },
  };
}

export default function RenderEventSchema({ event, locale, coverPhoto }) {
  return (
    <script
      key={`event-${event.id}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(renderSchema(event, locale, coverPhoto)),
      }}
    />
  );
}
